@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.add-tag-modal {
  width: 445px;
}

.modal-body {
  padding: 15px;
  max-height: 300px;
  overflow: auto;
}

.loading-indicator {
  padding: 0 10px;
  height: 50px;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}

.tags {
  margin-bottom: 15px;
}

.tag-row {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.add-new-tag-wrapper {
  text-align: center;
  padding-top: 15px;
  border-top: 1px solid @add-tags-modal--border-color;
}
